export default class ScrollTo {
    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {
        $('.js-scroll-to').on('click', function(e) {
            e.preventDefault();

            const $target = $(this).attr('href');

            $('html, body').animate({
                scrollTop: $($target).offset().top - 130
            }, 200);
        });

        // Scroll to reviews
        $('.js-open-reviews').on('click', () => {
            if(!$('.js-reviews-panel').hasClass('open')) {
                $('.js-reviews-btn').click();
            }

            $('html, body').animate({
                scrollTop: $('#reviews').offset().top - 130
            }, 200);
        });
    }
}
new ScrollTo();
